<template>
  <Swiper
    :slides-per-view="slidesPerView"
    :loop="false"
    :centered-slides="false"
    :initial-slide="0"
    :modules="modules"
    class="w-full"
  >
    <SwiperSlide v-for="item in slides.slice(0, 15)" :key="item.id">
      <NuxtLink :to="item?.url || '/'">
        <div class="relative flex items-center justify-center">
          <div class="aspect-h-[30] aspect-w-[26] cursor-pointer w-full h-full">
            <UiLazyImg
              class="h-full w-full"
              :src="item.image || '/images/no-image.webp'"
              :alt="item.currentTranslation?.title || 'image'"
              img-classes="object-cover"
            />
          </div>
          <div
            class="ui-text-xs text-white font-medium absolute bottom-2 right-0 px-2"
          >
            {{ item.currentTranslation?.title }}
          </div>
        </div>
      </NuxtLink>
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
import { NavMenuItem } from "ecom-types";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";

const modules = [Navigation];

withDefaults(
  defineProps<{
    slides: NavMenuItem[];
    slidesPerView?: number;
  }>(),
  {
    slidesPerView: 2,
  },
);
</script>
